import { FunctionComponent, useRef } from 'react'
import ReactQuill from 'react-quill-new'
import Select from 'react-select'
import { Button, Form } from 'react-bootstrap'
import { quillModules, getSemanticHtml } from 'Frontend/scripts/quillModules'
import { IWorkroomTypeSelect } from 'Frontend/scripts/models/workrooms.model'
import { createWorkroom } from 'Frontend/scripts/services/workrooms.service'

import { useForm, Controller } from 'react-hook-form'
import { IAntiforgeryToken } from 'Frontend/scripts/models/general.model'
import { getAntiforgeryToken } from 'Frontend/scripts/services/general.service'
import { useTranslation } from 'react-i18next'

const workroomTypes: IWorkroomTypeSelect[] = [
  { value: '0', label: 'Nationella' },
  { value: '1', label: 'Regionala' },
]
const CreateNewWorkroom: FunctionComponent = () => {
  const quillRef = useRef<ReactQuill | null>(null)
  const { t } = useTranslation()

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      description: '',
      reason: '',
      selectedType: '',
    },
  })

  const onSubmit = (data: any) => {
    const mainBodyWithCorrectHTML = getSemanticHtml(quillRef)
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      createWorkroom(
        token.csrfToken,
        data.name,
        mainBodyWithCorrectHTML,
        data.reason,
        parseInt(data.selectedType.value),
        false,
      ).then((successfullyCreated: boolean) => {
        if (successfullyCreated) {
          window.location.href = `${window.location.href}success`
        }
      })
    })
  }

  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column gap-3">
      <Form.Group>
        <Form.Label htmlFor="inputName">{t('name')}</Form.Label>
        <Form.Control id="inputName" type="text" {...register('name', { required: t('error-add-name-workroom') })} />
        {errors.name && <Form.Text className="text-danger">{errors.name.message}</Form.Text>}
      </Form.Group>

      <Form.Group>
        <Form.Label htmlFor="inputDescription">{t('description')}</Form.Label>
        <Controller
          name="description"
          control={control}
          rules={{ validate: (value) => value?.replace(/<(.|\n)*?>/g, '').trim().length > 0 || t('error-description') }}
          render={({ field }) => (
            <ReactQuill
              {...field}
              ref={quillRef}
              id="inputDescription"
              className="notice__quill-editor"
              theme="snow"
              modules={quillModules}
              onChange={(value) => setValue('description', value, { shouldValidate: true })}
            />
          )}
        />
        {errors.description && <Form.Text className="text-danger">{errors.description.message}</Form.Text>}
      </Form.Group>

      <Form.Group>
        <Form.Label htmlFor="inputReason">{t('describe-reason')}</Form.Label>
        <Form.Control as="textarea" id="inputReason" {...register('reason')} />
      </Form.Group>

      <Form.Group>
        <Form.Label htmlFor="selectedType">{t('type-of-workroom')}</Form.Label>
        <Controller
          name="selectedType"
          control={control}
          rules={{ required: t('error-type-of-workroom') }}
          render={({ field }) => (
            <Select
              inputId="selectedType"
              options={workroomTypes}
              placeholder={t('chose-type-of-workroom')}
              classNamePrefix="single-select"
              onChange={(value) => field.onChange(value)}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: '1.6rem',
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: '1.6rem',
                }),
              }}
            />
          )}
        />
        {errors.selectedType && <Form.Text className="text-danger">{errors.selectedType.message}</Form.Text>}
      </Form.Group>

      <div className="d-flex gap-3">
        <Button variant="secondary" type="submit">
          {t('create-workroom')}
        </Button>
        <Button variant="outline-secondary" type="button" onClick={() => window.history.go(-1)}>
          {t('abort')}
        </Button>
      </div>
    </Form>
  )
}

export default CreateNewWorkroom
